import { JackpotLevel, JackpotValue2 } from "./api";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { MoneyFormatter } from "./MoneyFormatter";
import { LogGroup, Scale, Size } from "./MyHelpers";
import { MyVideo } from "./MyVideo";
import { FontResource } from "./ResourceManager/FontResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocol, ScreenProtocolScope } from "./ScreenProtocol";
import { Settings } from "./Settings";
import { PickBonusMessages } from "./slot/PickBonus/PickMessage";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { ZIndex } from "./ZIndex";

export class JackpotDisplayJubileeLink extends IJackpotDisplay 
{

    protected view: HTMLElement = null;
	protected viewSize: Size = null;
	//Creating elements for JP
	//protected jpTitle: HTMLElement = null;
	protected titleImage: HTMLElement = null;
	protected JP4JubileeLinkContainer: HTMLElement = null;
	protected diamondImage: HTMLElement = null;
	//protected diamondvalue: HTMLElement = null;
	//protected diamondText: HTMLElement = null;
	protected JP3JubileeLinkContainer: HTMLElement = null;
	protected rubyImage: HTMLElement = null;
	//protected rubyvalue: HTMLElement = null;
	//protected rubyText: HTMLElement = null;
	protected JP1JubileeLinkContainer: HTMLElement = null;
	protected emeraldImage: HTMLElement = null;
	protected emeraldText: HTMLElement = null;
	protected JP2JubileeLinkContainer: HTMLElement = null;
	protected saphireImage: HTMLElement = null;


	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;

	//crea el contenedor como elemento HTMLElement
	//protected jackpotContainer: HTMLElement = null;

	// protected diamondSpriteAnim: CanvasSprite = null;
	// protected diamondLocation: Point = new Point(8,-34);
	protected diamondStartTimer: IRandomInterval = null;

	// protected rubyAnim: CanvasSprite = null;
	// protected rubyLocation: Point = new Point(365,80);
	protected rubyStartTimer: IRandomInterval = null;

	// protected shappireAnim: CanvasSprite = null;
	// protected shappireLocation: Point = new Point(635,920);
	protected shappireStartTimer: IRandomInterval = null;

	// protected emeraldAnim: CanvasSprite = null;
	// protected emeraldLocation: Point = new Point(617,720);
	protected emeraldStartTimer: IRandomInterval = null;

	//LOAD JACKPOT SPRITE
	protected JP4SpriteJackpot: CanvasSprite;
	protected JP3SpriteJackpot: CanvasSprite;
	protected JP2SpriteJackpot: CanvasSprite;
	protected JP1SpriteJackpot: CanvasSprite;


	protected titleSpriteAnim: CanvasSprite = null;
	protected titleStartTimer: IRandomInterval = null;

	protected screenProtocol: ScreenProtocol = null;

	protected logGroup: LogGroup = new LogGroup("JackpotDisplayJubileeLink");

	protected systemContext: ISystemContext = null;

	protected allJpTimers: IRandomInterval[] = [];

	protected allJpSpriteAnim: CanvasSprite[] = [];

	protected TitleContainer: HTMLElement = null;
	protected videoContainer: HTMLElement = null;

	protected  playvideo: MyVideo

	public constructor(params: JackpotDisplayParams) {
		super(params)

		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayJubileeLink");

		this.resid = params.resid.Add("JackpotDisplayJubileeLink");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayJubileeLink");

		this.screenProtocol = params.screenProtocol;
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";
		this.viewSize = params.viewSize;

		// this would be "view" with jackpot frames
		this.view = document.createElement("div");
		this.view.classList.add(this.resid.ID());
		this.view.style.position = "absolute";
		this.view.style.top = Scale.Ypx(0);
		this.view.style.left = Scale.Xpx(0);
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";
		this.view.style.zIndex = "" + ZIndex.JackpotDisplay;

		//Video
		this.videoContainer = document.createElement("div");
		this.videoContainer.setAttribute("id", "videoContainer");
		this.videoContainer.classList.add(this.resid.ScopedResourceName("videoContainer"));
		this.videoContainer.style.display = "block";
		this.videoContainer.style.top = Scale.Ypx(0);
		this.videoContainer.style.left = Scale.Xpx(0);
		this.videoContainer.style.position = "absolute";
		this.videoContainer.style.width = Scale.Wpx(1920);
		this.videoContainer.style.height = Scale.Hpx(1080);
		this.view.appendChild(this.videoContainer);
		//Title Container 
		this.TitleContainer = document.createElement("div");
		this.TitleContainer.setAttribute("id", "TitleContainer");
		this.TitleContainer.classList.add(this.resid.ScopedResourceName("TitleContainer"));
		this.TitleContainer.style.display = "block";
		//this.TitleContainer.style.justifyContent = "center";
		//this.TitleContainer.style.alignContent = "center";
		this.TitleContainer.style.left = Scale.Xpx(0);
		this.TitleContainer.style.bottom = "0px";
		this.TitleContainer.style.position = "absolute";

		// need to get position from image
		this.TitleContainer.style.width = Scale.Wpx(900);
		this.TitleContainer.style.height = Scale.Hpx(550);
		this.view.appendChild(this.TitleContainer);



		//Diamond  titleContainer DIV

		//Diamond Jackpot
		this.JP4JubileeLinkContainer = document.createElement("div");
		this.JP4JubileeLinkContainer.setAttribute("id", "JP4JubileeLinkContainer");
		this.JP4JubileeLinkContainer.classList.add(this.resid.ScopedResourceName("JP4JubileeLinkContainer"));
		//this.JP4JubileeLinkContainer.style.display = "flex";
		//this.JP4JubileeLinkContainer.style.justifyContent = "center";
		//this.JP4JubileeLinkContainer.style.alignContent = "center";
		this.JP4JubileeLinkContainer.style.placeContent = "flex-end";
		this.JP4JubileeLinkContainer.style.right = Scale.Xpx(-5);
		this.JP4JubileeLinkContainer.style.top = Scale.Ypx(23);
		this.JP4JubileeLinkContainer.style.position = "absolute";

		// need to get position from image
		this.JP4JubileeLinkContainer.style.width = Scale.Wpx(1830);
		this.JP4JubileeLinkContainer.style.height = Scale.Hpx(375);
		this.view.appendChild(this.JP4JubileeLinkContainer);

		//Ruby Jackpot
		this.JP3JubileeLinkContainer = document.createElement("div");
		this.JP3JubileeLinkContainer.setAttribute("id", "JP3JubileeLinkContainer");
		this.JP3JubileeLinkContainer.classList.add(this.resid.ScopedResourceName("ruby"));
		this.JP3JubileeLinkContainer.style.position = "absolute";
		this.JP3JubileeLinkContainer.style.display = "flex";
		this.JP3JubileeLinkContainer.style.top = Scale.Ypx(333);
		this.JP3JubileeLinkContainer.style.right = Scale.Xpx(60);
		this.JP3JubileeLinkContainer.style.width = Scale.Wpx(1350);
		this.JP3JubileeLinkContainer.style.height = Scale.Hpx(375);
		this.view.appendChild(this.JP3JubileeLinkContainer);



		//Emerald Jackpot
		this.JP2JubileeLinkContainer = document.createElement("div");
		this.JP2JubileeLinkContainer.setAttribute("id", "JP2JubileeLinkContainer");
		this.JP2JubileeLinkContainer.classList.add(this.resid.ScopedResourceName("JP2JubileeLinkContainer"));
		this.JP2JubileeLinkContainer.style.position = "absolute";
		this.JP2JubileeLinkContainer.style.top = Scale.Ypx(840);
		this.JP2JubileeLinkContainer.style.right = Scale.Xpx(662);
		this.JP2JubileeLinkContainer.style.width = Scale.Wpx(820);
		this.JP2JubileeLinkContainer.style.height = Scale.Hpx(250);
		this.view.appendChild(this.JP2JubileeLinkContainer);
		//Shappire Jackpot
		

        this.JP1JubileeLinkContainer = document.createElement("div");
		this.JP1JubileeLinkContainer.setAttribute("id", "JP1JubileeLinkContainer");
		this.JP1JubileeLinkContainer.classList.add(this.resid.ScopedResourceName("sapphire"));
		this.JP1JubileeLinkContainer.style.position = "absolute";
		this.JP1JubileeLinkContainer.style.top = Scale.Ypx(840);
		this.JP1JubileeLinkContainer.style.right = Scale.Xpx(-30);
		this.JP1JubileeLinkContainer.style.width = Scale.Wpx(820);
		this.JP1JubileeLinkContainer.style.height = Scale.Hpx(250);
		this.view.appendChild(this.JP1JubileeLinkContainer);






		// recieve message from first screen
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.DiamondAnimation.msgname, (m) => this.DiamondAnimation((<PickBonusMessages.DiamondAnimation>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.JpShowFinish.msgname, (m) => this.JpShowFinish((<PickBonusMessages.JpShowFinish>m)), this.screenProtocolScope);

		
	}


	protected DiamondAnimation(message: PickBonusMessages.DiamondAnimation) {
		this.allJpTimers.forEach((anim: IRandomInterval) => {
			anim.Stop();
		});

		if (message.hitJp == 1) {
			this.JP1SpriteJackpot.Start(true);
		}

		if (message.hitJp == 2) {
			this.JP2SpriteJackpot.Start(true);
		}

		if (message.hitJp == 3) {
			this.JP3SpriteJackpot.Start(true);
		}

		if (message.hitJp == 4) {
			this.JP4SpriteJackpot.Start(true);
		}
	}

	protected JpShowFinish(message: PickBonusMessages.JpShowFinish) {
		this.allJpSpriteAnim.forEach((anim: CanvasSprite) => {
			if (anim.sprite.Running()) {
				anim.Repeat(false);
				//anim.Start(false);
				// anim.sprite.Stop();
				// anim.sprite.Update();
			}
		});

		this.StartAnimations();
	}

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		
		// resourceManager.Add(new VideoResource2({
		// 	resid: ResourceIdentifier.Global.Add("JubileeLink_Background"),
		// 	logGroup: LogGroup.Global.Add("JubileeLink_Background"),
		// 	src: Settings.ResourcesFolder + "multigame/multigame/Jubilee/videobackground",
		// 	unloadOnEnd: true
		// }));

		// resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/RubyJubileeLink", this.resid.Add("RubyJubileeLink"), true, this.logGroup.Add("RubyJubileeLink"), true));
		// resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/DiamondJubileeLink", this.resid.Add("DiamondJubileeLink"), true, this.logGroup.Add("DiamondJubileeLink"), true));
		// resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/EmeraldJubileeLink", this.resid.Add("EmeraldJubileeLink"), true, this.logGroup.Add("EmeraldJubileeLink"), true));
		// resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/SapphireJubileeLink", this.resid.Add("SapphireJubileeLink"), true, this.logGroup.Add("SapphireJubileeLink"), true));
		this.PrepareJpContainer(resourceManager);
		this.TitlePrepare(resourceManager);
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));

	}

	protected PrepareJpContainer(resourceManager : IWriteOnlyResourceManager)
	{
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/RubyJubileeLink", this.resid.Add("RubyJubileeLink"), true, this.logGroup.Add("RubyJubileeLink"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/DiamondJubileeLink", this.resid.Add("DiamondJubileeLink"), true, this.logGroup.Add("DiamondJubileeLink"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/EmeraldJubileeLink", this.resid.Add("EmeraldJubileeLink"), true, this.logGroup.Add("EmeraldJubileeLink"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/SapphireJubileeLink", this.resid.Add("SapphireJubileeLink"), true, this.logGroup.Add("SapphireJubileeLink"), true));

	}

	public TitlePrepare(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/JubileeLinkTitle", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public TitleLoaded(resourceManager: IReadOnlyResourceManager) {
		this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.W(700), Scale.H(400))});
		this.titleSpriteAnim.View().style.position = "absolute";
		this.titleSpriteAnim.View().style.bottom="100px";
		this.titleSpriteAnim.View().style.left="0px";
		//this.titleSpriteAnim.Scale(1.1);
		this.TitleContainer.appendChild(this.titleSpriteAnim.View());
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;

		// let video: MyVideo = resourceManager.Get<VideoResource2>(ResourceIdentifier.Global.Add("JubileeLink_Background")).video;
		// SetStyles(video.View(),{position: "absolute", top: Scale.Ypx(0), left: Scale.Xpx(0), width: Scale.Wpx(1920), height: Scale.Hpx(1080)});
		// this.systemContext.SharedVideoContext().AddVideo(video);
		

		//  this.playvideo= this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add("JubileeLink_Background"));
		
		
		// this.playvideo.View().style.zIndex = "" + ZIndex.JackpotDisplayBackground;

		this.TitleLoaded(resourceManager);





		// //this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		// this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(this.logGroup.Add("White"), Scale.W(1500), Scale.H(175), "black", "black", this.resid.ScopedResourceName("JackpotFont"), this.moneyFormatter, 0);
		// this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(338);
		// this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(114); //84
		// this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		// this.JP4JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());



		// //JackpotFont 3
		// this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(this.logGroup.Add("Red"), Scale.W(940), Scale.H(150), "black", "black", this.resid.ScopedResourceName("JackpotFont"), this.moneyFormatter, 0);
		// this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(345);
		// this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(130);
		// this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		// this.JP3JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		// //JackpotFont 2
		// this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(this.logGroup.Add("Green"), Scale.W(400), Scale.H(70), "black", "black", this.resid.ScopedResourceName("JackpotFont"), this.moneyFormatter, 0);
		// this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(320);
		// this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(100);
		// this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		// this.JP2JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());


		// //JackpotFont 1
		// this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(this.logGroup.Add("Blue"), Scale.W(400), Scale.H(70), "black", "black", this.resid.ScopedResourceName("JackpotFont"), this.moneyFormatter, 0);
		// this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(320);
		// this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(100);
		// this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		// this.JP1JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());


		//this.DragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("diamond_frame")).CssBackground();

		this.CreateJPText();
				//this.GrandDragonJackpotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("ruby_frame")).CssBackground();
		this.JP3SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("DiamondJubileeLink")).sprite, canvasSize: new Size(Scale.W(1350), Scale.H(375))});
		//this.JP3SpriteJackpot.Start();
		this.JP3JubileeLinkContainer.appendChild(this.JP3SpriteJackpot.View());
		

		this.JP4SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("RubyJubileeLink")).sprite, canvasSize: new Size(Scale.W(1830), Scale.H(375))});
		//this.JP4SpriteJackpot.Start();
		this.JP4JubileeLinkContainer.appendChild(this.JP4SpriteJackpot.View());
        //this.JP4SpriteJackpot.ScaleNonUniform(1.1,1);


		//this.MiniDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("emerald_frame")).CssBackground();
		this.JP2SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("EmeraldJubileeLink")).sprite, canvasSize: new Size(Scale.W(820), Scale.H(250))});
		//this.JP2SpriteJackpot.Start();
		this.JP2SpriteJackpot.ScaleNonUniform(1.22, 1);
		this.JP2JubileeLinkContainer.appendChild(this.JP2SpriteJackpot.View());



		//this.MinorDragonJackotContainer.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("sapphire_frame")).CssBackground();
		this.JP1SpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("SapphireJubileeLink")).sprite, canvasSize: new Size(Scale.W(820), Scale.H(250))});
		//this.JP1SpriteJackpot.Start();
		this.JP1SpriteJackpot.ScaleNonUniform(1.22,1);
		this.JP1JubileeLinkContainer.appendChild(this.JP1SpriteJackpot.View());

		this.allJpSpriteAnim.push(this.JP4SpriteJackpot);
		this.allJpSpriteAnim.push(this.JP3SpriteJackpot);
		this.allJpSpriteAnim.push(this.JP2SpriteJackpot);
		this.allJpSpriteAnim.push(this.JP1SpriteJackpot);



		// repeat at random intervals winthin 5 to 10 seconds
		this.diamondStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 10000, 30000, () => this.JP4SpriteJackpot.Start(false));
		this.rubyStartTimer = this.systemContext.TimingContext().CreateRandomInterval("rubyStartTimer", 10000, 30000, () => this.JP3SpriteJackpot.Start(false));
		this.shappireStartTimer = this.systemContext.TimingContext().CreateRandomInterval("shappireStartTimer", 10000, 30000, () => this.JP1SpriteJackpot.Start(false));
		this.emeraldStartTimer = this.systemContext.TimingContext().CreateRandomInterval("emeraldStartTimer", 10000, 30000, () => this.JP2SpriteJackpot.Start(false));
		this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 10000, 30000, () => this.titleSpriteAnim.Start(false));

		this.allJpTimers.push(this.diamondStartTimer);
		this.allJpTimers.push(this.rubyStartTimer);
		this.allJpTimers.push(this.shappireStartTimer);
		this.allJpTimers.push(this.emeraldStartTimer);

		this.StartAnimations();

		this.Update();

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();
	}

	protected CreateJPText()
	{
		let jp4TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("White"),
			width: Scale.W(1500),
			height: Scale.H(175),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(338);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(114); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.JP4JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());

		let jp3TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(940),
			height: Scale.H(150),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont 3
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(345);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(130);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.JP3JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		let jp2TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(400),
			height: Scale.H(70),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			//bold: true,
		}
		//JackpotFont 2
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(320);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(100);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.JP2JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());

		let jp1TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(400),
			height: Scale.H(70),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			//bold: true,
		}
		//JackpotFont 1
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(320);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(100);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		this.JP1JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());


	}

	// deleted too much, this is how this particular game gets displayed to screen,
	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void {
		// animation needs to be updated for frames to go forward
		// this.diamondSpriteAnim.Update();
		// this.rubyAnim.Update();
		// this.shappireAnim.Update();
		// this.emeraldAnim.Update();
		this.titleSpriteAnim.Update();
		this.jackpotTextMapping[JackpotLevel.Jp4].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3].Draw();
		//Change STYLE JP1 and JP2
		this.jackpotTextMapping[JackpotLevel.Jp1].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2].Draw();
		//UPDATE JACKPOT ANIM
		this.JP4SpriteJackpot.Update();
		this.JP3SpriteJackpot.Update();
		this.JP2SpriteJackpot.Update();
		this.JP1SpriteJackpot.Update();
	}

	public StopAnimations(): void {
		// stop animations and their timer to startup in near future

		// if (this.diamondSpriteAnim != null) this.diamondSpriteAnim.Stop();
		// this.diamondStartTimer.Stop();

		// if (this.rubyAnim != null) this.rubyAnim.Stop();
		// this.rubyStartTimer.Stop();

		// if (this.shappireAnim != null) this.shappireAnim.Stop();
		// this.shappireStartTimer.Stop();

		// if (this.emeraldAnim != null) this.emeraldAnim.Stop();
		// this.emeraldStartTimer.Stop();

		if (this.titleSpriteAnim != null) this.titleSpriteAnim.Stop();
		this.titleStartTimer.Stop();
	}

	public StartAnimations(): void {

		
		//start within 5 seconds
		if (this.JP4SpriteJackpot != null) {
			this.diamondStartTimer.Start();
		}

		if (this.JP3SpriteJackpot != null) {
			this.rubyStartTimer.Start();
		}

		if (this.JP1SpriteJackpot != null) {
			this.shappireStartTimer.Start()
		}

		if (this.JP2SpriteJackpot != null) {
			this.emeraldStartTimer.Start()
		}

		if (this.titleSpriteAnim != null) {
			this.titleStartTimer.Start()
		}
	}

	// protected jpValues: JackpotValue2[] = [];
	// public UpdateValues(jackpotValues: JackpotValue2[]): void {
	// 	this.jpValues = jackpotValues;
	// 	if (this.pauseJackpotValues) {
	// 		console.log("IsJackpot");
	// 		return
	// 	}
	// 	let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp1);
	// 	if (jp1 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp1].SetTarget(jp1.CurrentMultipliedValue);
	// 	}

	// 	let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp2);
	// 	if (jp2 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp2].SetTarget(jp2.CurrentMultipliedValue);
	// 	}

	// 	let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp3);
	// 	if (jp3 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp3].SetTarget(jp3.CurrentMultipliedValue);
	// 	}

	// 	let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == JackpotLevel.Jp4);
	// 	if (jp4 != null) {
	// 		this.jackpotTextMapping[JackpotLevel.Jp4].SetTarget(jp4.CurrentMultipliedValue);
	// 	}
	// }

	public TitleHide() {
		this.titleSpriteAnim.Hide();
		this.titleSpriteAnim.Stop();
	}
	public TitleShow() {
		this.titleSpriteAnim.Show();
		this.titleStartTimer.Start()
	}

	// public Reset() {
	// 	console.log("Reset JackpotValues:");
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "ResetValue:", jp.ResetValue);
	// 	});
	// }

	// public Resume() {
	// 	console.log("Resume JackpotValues:");
	// 	this.pauseJackpotValues = false;
	// 	this.jpValues.forEach((jp) => {
	// 		console.log("JackpotValuesLevel:", jp.JackpotLevel, "CurrentValue:", jp.CurrentValue);
	// 	});
	// 	this.UpdateValues(this.jpValues);
	// }

	// protected pauseJackpotValues = false;
	// public Pause() {
	// 	console.log("Pause JackpotValues");
	// 	this.pauseJackpotValues = true;
	// }
}
